import api from '@/services/api.js';

export default {
    getAll(){
        return api.get('/access-groups');
    }
}